<div class="Flexbox Flexbox--column Gap--larger SummaryContent">
  <div class="Flexbox Gap--larger">
    <ng-container >
      <ul class="AttributeList Flexbox Flexbox--column Gap--normal">
        <li *ngFor="let displayableAttribute of displayableSelectedAttributes" class="Flexbox Gap--smaller">
          <mat-card>
            <mat-card-content>
              <div *ngIf="displayableAttribute.children" class="Flexbox Flexbox--column Gap--smaller">
                <span>{{ displayableAttribute.name }}</span>
                <div class="Flexbox Gap--smaller" *ngFor="let childAttribute of displayableAttribute.children">
                  <span>{{ childAttribute.name }}</span>
                  <span class="AttributeValue"><b>{{ childAttribute.value }}</b></span>
                </div>
              </div>
              <ng-container *ngIf="!displayableAttribute.children">
                <span>{{ displayableAttribute.name }}</span>
                <span class="AttributeValue"><b>{{ displayableAttribute.value }}</b></span>
              </ng-container>
            </mat-card-content>
          </mat-card>
        </li>
      </ul>
    </ng-container>
    <app-main-image></app-main-image>
  </div>
  <div class="Flexbox Flexbox--column BottomContainer">
    <mat-card>
      <mat-card-content>
        <mat-form-field appearance="outline" class="PO">
          <mat-label>PO #</mat-label>
          <input matInput>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content>
        <div class="Flexbox Flexbox--column PSD Align--center Gap--smaller">
          <p>Order Today, Ships By:</p>
          <h3>Thursday September 7</h3>
          <p><b>NO HASSLE</b> 35 day <b>RETURNS</b></p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
